import { render, staticRenderFns } from "./KeywordTopStatCard.vue?vue&type=template&id=113aec48&scoped=true&"
import script from "./KeywordTopStatCard.vue?vue&type=script&lang=js&"
export * from "./KeywordTopStatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113aec48",
  null
  
)

export default component.exports